const html = require('choo/html')
const Button = require('../elements/button.js')
const PanelElement = require('../elements/panel.js')

module.exports = function SharingJourneyPanel(state, emit) {
  const nextButton = Button({
    text: 'NEXT',
    size: 'medium',
    type: 'icon-aligned',
    color: 'pink',
    onClick: () => emit('sharing-mode-next')
  })

  const cancelButton = Button({
    text: 'CANCEL',
    size: 'small',
    onClick: () => emit('cancel-sharing-mode')
  })

  const currentSceneIndex = state.sharingMode.currentSceneIndex !== null && state.sharingMode.currentSceneIndex !== undefined
    ? state.sharingMode.currentSceneIndex
    : (state.project && state.project.scenes ? state.project.scenes.indexOf(state.currentScene) : 0)
  
  const isAtFirstLevel = currentSceneIndex === 0

  const backButton = Button({
    text: 'BACK',
    size: 'small',
    disabled: isAtFirstLevel,
    onClick: () => {
      if (!isAtFirstLevel) {
        emit('sharing-mode-back')
      }
    }
  })

  return PanelElement({
    color: 'purple',
    size: 'small',
    children: html`
      <div class="project-actions">
        <p style="margin-bottom: var(--size-2);">all the pieces where they should be?</p>
        ${nextButton}
        <div class="project-actions-row">
          ${backButton}
          ${cancelButton}
        </div>
      </div>
    `
  })
}

